var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"header-box fixed-top"},[_c('nav',{staticClass:"w1200 nav-header"},[_c('router-link',{staticClass:"logo",attrs:{"to":"/"}},[_c('img',{attrs:{"src":_vm.logo,"alt":""}})]),_c('navBox')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }